module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/about__background-35107ef4ebe80592a7c85d36cf705634.jpg";